<!--Validación del estado de la conexión-->
@if (isSlowConnection) {
  <div class="alert">
    ⚠ La conexión de internet es lenta.
  </div>
}

<app-page-title [title]="pageTitle" backRoute="/interventions" backTooltip="Regresar a Salida de material"></app-page-title>
<app-page-loader [load]="pageLoad" [label]="pageTitle" (retry)="init()"></app-page-loader>

<app-kpi-strip [kpis]="kpis" [active]="activeKpi" (activeChange)="setKpi($event)"></app-kpi-strip>

<div class="filter-bar">
  <div class="filter-card">
    <app-search-pill [value]="searchText" [placeholder]="isRemissionMode ? 'Folio, hospital, médico…' : 'Folio, paciente, médico, procedimiento…'" (valueChange)="setSearch($event)"></app-search-pill>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="date-field">
      <mat-label>Periodo</mat-label>
      <mat-date-range-input [formGroup]="dateRangeForm" [rangePicker]="picker">
        <input matStartDate formControlName="start" (dateChange)="onDateChange($event, 'start')" placeholder="Fecha inicial">
        <input matEndDate formControlName="end" (dateChange)="onDateChange($event, 'end')" placeholder="Fecha final">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="hospital-filter">
      <mat-label>Hospitales</mat-label>
      <mat-select multiple [(value)]="hospitalFilter" (selectionChange)="onHospitalFilterChange()" placeholder="Todos">
        <mat-select-trigger>
          {{ hospitalFilter.length ? hospitalLabel(hospitalFilter[0]) : 'Todos' }}
          @if (hospitalFilter.length > 1) { <span class="example-additional-selection">(+{{ hospitalFilter.length - 1 }} más)</span> }
        </mat-select-trigger>
        @for (p of hospitalFilterOptions; track p.id) {
          <mat-option [value]="p.id">{{ p.alias || p.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <button mat-stroked-button type="button" class="more-btn" [class.more-btn--open]="showMoreFilters" (click)="showMoreFilters = !showMoreFilters">
      <mat-icon>tune</mat-icon> Más filtros
      @if (activeFilterChips.length > 0) {<span class="more-btn__count">{{ activeFilterChips.length }}</span>}
      <mat-icon class="more-btn__caret">{{ showMoreFilters ? 'expand_less' : 'expand_more' }}</mat-icon>
    </button>

    <button mat-flat-button color="primary" type="button" class="apply-btn" (click)="getInterventions()">
      <mat-icon>filter_alt</mat-icon> Aplicar
    </button>
    <span class="filter-card__spacer"></span>
    <mat-button-toggle-group class="view-toggle" [value]="listView.mode" (change)="listView.set($event.value)" [hideSingleSelectionIndicator]="true" aria-label="Vista">
      <mat-button-toggle value="table" matTooltip="Vista de tabla"><mat-icon>table_rows</mat-icon></mat-button-toggle>
      <mat-button-toggle value="cards" matTooltip="Vista de tarjetas"><mat-icon>grid_view</mat-icon></mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  @if (showMoreFilters) {
  <div class="filter-more">
      <mat-form-field appearance="outline" subscriptSizing="dynamic" >
        <mat-label class="label">Médico</mat-label>
        <mat-select
          #doctorSelect
          class="selector"
          [formControl] = "doctorControl" multiple
          [(value)]="doctor">
          <mat-select-trigger>
            {{doctorControl.value?.[0] && doctorObject ? doctorObject[doctorControl.value?.[0]] : ''}}
            @if ((doctorControl.value?.length || 0) > 1) {
              <span class="example-additional-selection">
                (+{{(doctorControl.value?.length || 0) - 1}} {{doctorControl.value?.length === 2 ? 'más' : 'más'}})
              </span>
            }
          </mat-select-trigger>
          <button mat-mini-fab color="primary" (click)="doctorSelect.close()"> <mat-icon >close</mat-icon> </button>
          <app-select-check-all [model]="doctorControl" [values]="doctorOptions"> </app-select-check-all>
          @for (option of doctorOptions; track option) {
            <mat-option [value]="option">{{ doctorObject[option] }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label class="label">Especialidad</mat-label>
        <mat-select
          #specialtySelect
          class="selector"
          [formControl] = "specialtyControl" multiple
          [(value)]="specialty"
          (selectionChange)="change()"
          >
          <mat-select-trigger>
            {{specialtyControl.value?.[0] && specialtyObject ? specialtyObject[specialtyControl.value?.[0]] :''}}
            @if ((specialtyControl.value?.length || 0) > 1) {
              <span class="example-additional-selection">
                (+{{(specialtyControl.value?.length || 0) - 1}} {{specialtyControl.value?.length === 2 ? 'más' : 'más'}})
              </span>
            }
          </mat-select-trigger>
          <button mat-mini-fab color="primary" (click)="specialtySelect.close()"> <mat-icon >close</mat-icon> </button>
          <app-select-check-all [model]="specialtyControl" [values]="specialtyOptions" (change)="change()"> </app-select-check-all>
          @for (option of specialtyOptions; track option) {
            <mat-option [value]="option">{{ specialtyObject[option] }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" subscriptSizing="dynamic" >
        <mat-label class="label">Procedimiento</mat-label>
        <mat-select
          #procedureSelect
          class="selector"
          [formControl] = "procedureControl" multiple
          [(value)]="procedure">
          <mat-select-trigger>
            {{procedureControl.value?.[0] && procedureObject ? procedureObject[procedureControl.value?.[0]] : ''}}
            @if ((procedureControl.value?.length || 0) > 1) {
              <span class="example-additional-selection">
                (+{{(procedureControl.value?.length || 0) - 1}} {{procedureControl.value?.length === 2 ? 'más' : 'más'}})
              </span>
            }
          </mat-select-trigger>
          <button mat-mini-fab color="primary" (click)="procedureSelect.close()"> <mat-icon >close</mat-icon> </button>
          <app-select-check-all [model]="procedureControl" [values]="procedureOptions"> </app-select-check-all>
          @for (option of procedureOptions; track option) {
            <mat-option [value]="option">{{ procedureObject[option] }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
  </div>
  }

  <app-filter-chips [chips]="activeFilterChips" [count]="length" [total]="dataSource?.data?.length" [noun]="isRemissionMode ? 'remisiones' : 'folios'" (remove)="removeFilter($event)" (clear)="clearAllFilters()"></app-filter-chips>
</div>

<div class="list-actions">
  <button mat-stroked-button (click)="pageLoad.refresh(getInterventions())"><mat-icon>refresh</mat-icon> Actualizar</button>
  @if (!isRemissionMode) {
    <button mat-stroked-button (click)="openDoctorPreference()" matTooltip="Formato GA con lo que más usa cada médico por cirugía">
      <mat-icon>medical_information</mat-icon> Preferencia médica
    </button>
  }
  @if (permissions && permissions['create']) {
    @if (isRemissionMode) {
      <button mat-flat-button color="primary" (click)="goToRemission()">
        <mat-icon>receipt_long</mat-icon> Nueva remisión
      </button>
    } @else {
      <button mat-flat-button color="primary" (click)="goToWizard()">
        <mat-icon>post_add</mat-icon> Nuevo folio
      </button>
    }
  }
</div>

<app-selection-bar [count]="sel.count" (export)="exportSelection()" (clear)="sel.clear()"></app-selection-bar>

<div class="indicators">
  <!--<mat-paginator class="spacer" [pageSize]="50" [pageSizeOptions]="[50]"></mat-paginator>-->
  <mat-paginator class="spacer" [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" (page)="pageEvent = OnPageChange($event)"></mat-paginator>
</div>

<mat-divider></mat-divider>


@if (interventionList?.length==0) {
  <mat-card align="center">
    {{ isRemissionMode ? 'No hay remisiones en este periodo.' : 'No hay folios.' }}
  </mat-card>
}

@if (pagedList && listView.mode === 'cards') {
  <div class="inv-cards cat-cards">
    @for (intervention of pagedList; track intervention.id; let i = $index) {
      <div class="cat-card" [class.cat-card--selected]="sel.isSelected(intervention)">
        <div class="cat-card__head">
          <mat-checkbox color="primary" [checked]="sel.isSelected(intervention)" (change)="sel.toggle(intervention)" matTooltip="Seleccionar"></mat-checkbox>
          <span class="cat-card__title">{{ intervention.fileNumber || 'Sin folio' }}</span>
          <span class="list-status" [ngClass]="statusCss(intervention.status)">{{ intervention.status }}</span>
        </div>
        <div class="cat-card__body">
          <div class="cat-card__field"><span class="cat-card__label">Técnico:</span><span class="cat-card__value">{{ technicianName(intervention) }}</span></div>
          @if (intervention._kind === 'REMISION') {
            <div class="cat-card__field"><span class="cat-card__label">Hospital:</span><span class="cat-card__value">{{ intervention._hospitalName || '—' }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Médico:</span><span class="cat-card__value">{{ intervention._doctorName || '—' }}</span></div>
          } @else {
            <div class="cat-card__field"><span class="cat-card__label">Hospital:</span><span class="cat-card__value">{{ intervention._hospitalName || '—' }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Procedimiento:</span><span class="cat-card__value">{{ procedureObject[intervention.procedure] || (intervention.status === 'Incompleto' ? 'Borrador (sin procedimiento)' : '—') }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Fecha Cx:</span><span class="cat-card__value">{{ intervention.interventionDatetime ? formatDate(intervention.interventionDatetime) : '—' }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Especialidad:</span><span class="cat-card__value">{{ intervention.specialty ? specialtyObject[intervention.specialty] : '—' }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Episodio:</span><span class="cat-card__value">{{ intervention.episode || '—' }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Médico:</span><span class="cat-card__value">{{ intervention.doctor ? doctorObject[intervention.doctor] : '—' }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Paciente:</span><span class="cat-card__value">{{ patientObject?.[intervention.patient]?.name || '—' }}</span></div>
          }
          <div class="cat-card__field"><span class="cat-card__label">Creado:</span><span class="cat-card__value">{{ intervention.createdOn ? formatDate(intervention.createdOn) : '—' }}</span></div>
        </div>
        <div class="cat-card__actions">
          @if (intervention._kind === 'REMISION') {
            @if (isRemissionDraft(intervention)) {
              <button matTooltip="Continuar borrador de remisión" color="accent" mat-icon-button (click)="goToRemission(intervention._remission)"><mat-icon>play_circle</mat-icon></button>
              <button matTooltip="Emitir remisión" color="primary" mat-icon-button (click)="emitRemission(intervention._remission)"><mat-icon>task_alt</mat-icon></button>
            }
            @if (intervention.status !== 'Cancelada' && intervention.status !== 'Facturada') {
              <button matTooltip="Cancelar remisión" color="warn" mat-icon-button (click)="cancelRemission(intervention._remission)"><mat-icon>cancel</mat-icon></button>
            }
          } @else {
            @if (!isClosedFolio(intervention) && permissions?.update) {
              <button matTooltip="Continuar folio" color="accent" mat-icon-button (click)="goToWizard(intervention)"><mat-icon>play_circle</mat-icon></button>
            }
            @if (canSignOnly(intervention) && permissions?.update) {
              <button matTooltip="Subir vale firmado" color="primary" mat-icon-button (click)="goToSign(intervention)"><mat-icon>upload_file</mat-icon></button>
            }
            @if (!isClosedFolio(intervention) && permissions?.delete) {
              <button matTooltip="Cancelar folio" color="warn" mat-icon-button (click)="openCancelDialog(intervention, i)"><mat-icon>cancel</mat-icon></button>
            }
          }
        </div>
      </div>
    }
  </div>
}

@if (pagedList && listView.mode === 'table') {
  <div>
    @if (dataSource.filteredData?.length > 0) {
      <div class="table-container mat-elevation-z8">
      <table mat-table [dataSource]="dataSource" class="full-width-table">
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef class="select-cell">
            <mat-checkbox color="primary" (change)="$event ? sel.toggleAll() : null" [checked]="sel.allSelected()" [indeterminate]="sel.someSelected()" matTooltip="Seleccionar todos los visibles"></mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row" class="select-cell">
            <mat-checkbox color="primary" (click)="$event.stopPropagation()" (change)="$event ? sel.toggle(row) : null" [checked]="sel.isSelected(row)"></mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef style="min-width: 125px !important">Estatus</th>
          <td mat-cell *matCellDef="let intervention" style="min-width: 125px !important">
        <div [ngClass]="statusCss(intervention.status)">
              {{ intervention.status }}
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="intervention">
          <th mat-header-cell *matHeaderCellDef>Procedimiento</th>
          <td mat-cell *matCellDef="let intervention">{{ intervention._kind === 'REMISION' ? 'Remisión directa' : (intervention.procedure ? procedureObject[intervention.procedure] : 'N/A') }}</td>
        </ng-container>
        <ng-container matColumnDef="program">
          <th mat-header-cell *matHeaderCellDef>Fecha Cx</th>
          <td mat-cell *matCellDef="let intervention">{{formatDate(intervention.interventionDatetime)}}</td>
        </ng-container>
        <ng-container matColumnDef="fileNumber">
          <th mat-header-cell *matHeaderCellDef>Folio</th>
          <td mat-cell *matCellDef="let intervention">{{intervention.fileNumber ?? 'N/A'}}</td>
        </ng-container>
        <ng-container matColumnDef="technician">
          <th mat-header-cell *matHeaderCellDef>Técnico</th>
          <td mat-cell *matCellDef="let intervention">{{ technicianName(intervention) }}</td>
        </ng-container>
        <ng-container matColumnDef="hospital">
          <th mat-header-cell *matHeaderCellDef>Hospital</th>
          <td mat-cell *matCellDef="let intervention">{{ intervention._hospitalName || 'N/A' }}</td>
        </ng-container>
        <ng-container matColumnDef="episode">
          <th mat-header-cell *matHeaderCellDef>Episodio</th>
          <td mat-cell *matCellDef="let intervention">{{intervention.episode ?? 'N/A'}}</td>
        </ng-container>
        <ng-container matColumnDef="specialty">
          <th mat-header-cell *matHeaderCellDef>Especialidad</th>
          <td mat-cell *matCellDef="let intervention">{{intervention.specialty ? specialtyObject[intervention.specialty] : 'N/A'}}</td>
        </ng-container>
        <ng-container matColumnDef="doctor">
          <th mat-header-cell *matHeaderCellDef>Médico</th>
          <td mat-cell *matCellDef="let intervention">{{ intervention.doctor ? doctorObject[intervention.doctor] : (intervention._doctorName || 'N/A') }}</td>
        </ng-container>
        <ng-container matColumnDef="patient">
          <th mat-header-cell *matHeaderCellDef>Nombre del Paciente</th>
          <td mat-cell *matCellDef="let intervention">{{intervention.patient ? patientObject[intervention.patient]?.name  : 'N/A'}}</td>
        </ng-container>
        <ng-container matColumnDef="createdOn">
          <th mat-header-cell *matHeaderCellDef>Fecha de Creación</th>
          <td mat-cell *matCellDef="let intervention">{{intervention.createdOn ?? 'N/A'}}</td>
        </ng-container>
        <ng-container matColumnDef="actions" stickyEnd>
          <th mat-header-cell *matHeaderCellDef style="min-width: 110px !important">Acciones</th>
          <td mat-cell *matCellDef="let intervention" style="min-width: 110px !important">
            @if (intervention._kind === 'REMISION') {
              @if (isRemissionDraft(intervention)) {
                <button matTooltip="Continuar borrador de remisión" color="accent" mat-icon-button (click)="goToRemission(intervention._remission)">
                  <mat-icon>play_circle</mat-icon>
                </button>
                <button matTooltip="Emitir remisión" color="primary" mat-icon-button (click)="emitRemission(intervention._remission)">
                  <mat-icon>task_alt</mat-icon>
                </button>
              }
              @if (intervention.status !== 'Cancelada' && intervention.status !== 'Facturada') {
                <button matTooltip="Cancelar remisión" color="warn" mat-icon-button (click)="cancelRemission(intervention._remission)">
                  <mat-icon>cancel</mat-icon>
                </button>
              }
            } @else {
            @if (!isClosedFolio(intervention) && permissions?.update) {
              <button matTooltip="Continuar folio" color="accent" mat-icon-button (click)="goToWizard(intervention)">
                <mat-icon>play_circle</mat-icon>
              </button>
            }
            @if (canSignOnly(intervention) && permissions?.update) {
              <button matTooltip="Subir vale firmado" color="primary" mat-icon-button (click)="goToSign(intervention)">
                <mat-icon>upload_file</mat-icon>
              </button>
            }
            @if (!isClosedFolio(intervention) && permissions?.delete) {
              <button matTooltip="Cancelar folio" color="warn" mat-icon-button (click)="openCancelDialog(intervention, i)">
                <mat-icon>cancel</mat-icon>
              </button>
            }
            }
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      </div>
    }
  </div>
}